













































































import {Component, Emit, Prop, Vue} from 'vue-property-decorator';
import {namespace} from 'vuex-class';
import {Quote} from '@/interfaces/order.interface';
import moment from 'moment';
import {Currency} from '@/interfaces/currency.interface';

const ordersModule = namespace('orders');
const defaultQuote: Quote = {eta: moment().add(1, 'd').format('YYYY-MM-DD')};

@Component
export default class QuoteForm extends Vue {
  @Prop({default: []}) order!: Quote;
  @Prop({default: () => defaultQuote}) quote?: Quote;
  @ordersModule.Action createQuote: any;
  @ordersModule.Action updateQuote: any;
  editableQuote: Quote = {};

  isUpdateMode = false;

  datepicker: any = false;

  mounted() {
    if (this.quote && this.quote.uuid) this.isUpdateMode = true;
    this.resetQuote();
  }

  private resetQuote() {
    this.editableQuote = {
      ...this.quote,
      ...{eta: this.quote && this.quote.eta && moment(this.quote.eta).format('YYYY-MM-DD')},
      ...{currency: 'EUR'}
    };
  }

  async addQuote() {
    try {
      await this.createQuote({
        orderUuid: this.order.uuid,
        quote: {
          ...this.editableQuote,
          ...{eta: moment(this.editableQuote.eta)}
        }
      });
      this.resetQuote();
    } catch (e) {
      console.log('Something went wrong');
    }
  }

  @Emit('quote-updated')
  async editQuote() {
    try {
      await this.updateQuote({quote: this.editableQuote});
      return this.editableQuote;
    } catch (e) {
      console.log('Something went wrong');
    }
  }

  get currencies(): Currency[] {
    return [
      {code: 'EUR'},
      {code: 'USD'},
      {code: 'GBP'}
    ];
  }
}
